import { Request } from '../../index'

export type KlassesChainsParams = {
  schoolId: string
  schoolYearId: string
}

export type EducationLevelsChains = Record<string, string[]>

type KlassesChainsApiParams = {
  school_id: number
  schoolyear_id: number
}

type KlassesChainsApiResult = Record<string, Array<string | number>>

export const convertParams = ({
  schoolId,
  schoolYearId,
}: KlassesChainsParams): [KlassesChainsApiParams, null] => [
  {
    school_id: Number(schoolId),
    schoolyear_id: Number(schoolYearId),
  },
  null,
]

export const convertResult = (apiData: KlassesChainsApiResult): EducationLevelsChains =>
  Object.fromEntries(
    Object.entries(apiData || {}).map(([title, parallels]) => [title, parallels.map(String)]),
  )

export const GET_KLASSES_CHAINS: Request<KlassesChainsParams, EducationLevelsChains, void> = [
  'reports/klasses_chains',
  'get',
  ['data', 'chains'],
]
